module.exports = __webpack_public_path__ + "static/media/jWilson.ab61e421.jpeg";